import React, {Component} from 'react';
import axios from 'axios';
import {toast} from 'react-toastify';

const $ = window.$;

export default class ModalDeleteAllImageForAccountManager extends Component {
    constructor(props) {
        super(props);
        console.log("vao ModalDeleteAllImageForAccountManager: " + this.props.images);
        this.state = {
            loading: false
        }
        this.deleteAllImage = this.deleteAllImage.bind(this);
    }

    deleteAllImage() {
        this.setState({
            loading: true
        });

        let json = {
            facebookId : this.props.id,
            firebaseIds : this.props.images.map((image, index) => {
                return image.id;
            })
        }

        axios.post(global.config.apiDomain + '/rest/admin/deleteAllImage', JSON.stringify(json), {
            headers: {
                'Content-Type': 'application/json'
            }
        }).then(res => {
            this.setState({
                loading: false
            });

            $("#modalDeleteAllImage").modal("hide");

            toast.success('Xóa thành công'); 
            this.props.resetImageList();
        })
    }

    render() {console.log("vao ModalDeleteAllImageForAccountManager 45: " + this.props.images);
        return (
            <>
                <div className="modal fade" id="modalDeleteAllImage" tabIndex={-1} role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
                    <div className="modal-dialog modal-dialog-centered" role="document">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title" id="exampleModalLabel">Xóa tất cả hình ảnh</h5>
                                <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">×</span>
                                </button>
                            </div>
                            {this.props.image ? (
                                <div className="modal-body">
                                <h3 className="text-center text-danger">Bạn chắc chắn muốn xóa tất cả ?</h3>
                            </div>
                            ) : ""}
                            <div className="modal-footer">
                                <button type="button" className="btn btn-red" data-dismiss="modal">Hủy</button>
                                {this.state.loading ? 
                                (
                                <button style={{width: "120px"}} className="btn btn-red" type="button" disabled>
                                <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                                        Xác nhận...
                                </button>
                                ) :
                                (
                                <button 
                                    style={{width: "120px"}} 
                                    type="button" 
                                    className="btn btn-red"
                                    onClick={this.deleteAllImage}>Xóa</button>                            
                                )}

                            </div>
                        </div>
                    </div>
                </div>
            </>
        )
    }
}